import {
  A,
  Box,
  Text,
  Flex,
  Image,
  Button,
  Devider,
  InputSearch,
  ModalContext,
  FormProvider,
  SearchContext,
  DashPlaceholder,
  PaginationPerPageSelect,
} from 'dash-ui';
import { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { useGetSaleTeamByIdQuery } from 'gql/generated.graphql';
import { ExternalSalesModalKeys } from 'pages/external-sales/constants/constants';
import { SaveExternalSaleModal } from 'pages/external-sales/external-sale-teams/components/SaveExternalSaleModal';
import { SaveSaleFormFieldsList } from 'pages/external-sales/external-sale-teams/constants';
import { useBrowserTabTitle } from 'common/hooks/use-browser-tab-title/use-browser-tab-title';

const ExternalSalesUsersHeader = () => {
  const theme = useTheme();
  const { id: saleTeamId = '' } = useParams();
  const { t } = useTranslation(['common', 'pages']);
  const { toggleModal, setPayload } = useContext(ModalContext);
  const { setSearchSlug } = useContext(SearchContext);
  const [searchValue, setSearchValue] = useState<string>('');

  const { data } = useGetSaleTeamByIdQuery({
    variables: { saleTeamId },
    skip: !saleTeamId,
  });
  const saleTeam = data?.getSaleTeamById;

  const addUser = () => {
    setPayload({ saleTeamId });
    toggleModal(true, ExternalSalesModalKeys.SaveSaleTeamUser);
  };

  useBrowserTabTitle(
    `${saleTeam ? saleTeam?.name : 'External Sales'} ${t(
      'common:labels.dashSuffix'
    )}`
  );

  return (
    <Box>
      <FormProvider fieldsList={SaveSaleFormFieldsList}>
        <SaveExternalSaleModal />
      </FormProvider>
      <Flex p={4}>
        {saleTeam?.logoFile ? (
          <Image src={saleTeam?.logoFile?.publicUrl || ''} size={80} />
        ) : (
          <DashPlaceholder size={80} />
        )}
        <Box ml={3} flex={1}>
          <Text semibold xl>
            {saleTeam?.name}
          </Text>
          {saleTeam?.website ? (
            <A href={saleTeam?.website || ''} target="_blank">
              {saleTeam?.website}
            </A>
          ) : (
            <Text>{t('pages:organisationPage.websiteUnavailable')}</Text>
          )}
        </Box>
        <Button
          data-testid="edit-team"
          variation="outline"
          round
          icon="edit"
          onClick={() => {
            setPayload(saleTeam);
            toggleModal(true, ExternalSalesModalKeys.SaveExternalSaleTeam);
          }}
        />
      </Flex>
      <Devider color={theme.colors.n40} />
      <Flex p={4}>
        <InputSearch
          onClear={() => {
            setSearchSlug('');
            setSearchValue('');
          }}
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value);
            setSearchSlug(e.target.value);
          }}
          w="100%"
          css={'height: 40px'}
          placeholder={t('common:labels.search') || ''}
        />
        <PaginationPerPageSelect
          mx={3}
          maxWidth={130}
          w="100%"
          label={t('common:labels.show') || ''}
        />
        <Button icon="plus" w={170} px={4} onClick={addUser}>
          {t('pages:externalSalesPage.addUser')}
        </Button>
      </Flex>
    </Box>
  );
};

export default ExternalSalesUsersHeader;
